
import { defineComponent, onBeforeMount, ref } from "vue";
import { RepositoryException } from "../../../domain/exceptions/exceptions";
import { dispatchErrorBox } from "../components/mixins";
import { useStore } from "vuex";
import { CourseTrack } from "../../../domain/entities/entities";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import course from "../components/application/Course.vue";
import courseTrack from "../components/application/CourseTrack.vue";
import CourseTrackFilter from "../components/application/filters/CourseTrack.vue";
import { wrapLoading } from "../utils/wrap_loading";
import { dispatchError } from "../utils/error_handling";

export default defineComponent({
  name: "SearchSchools",
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
    course,
    courseTrack,
    CourseTrackFilter
  },
  props: {
    entityID: String
  },
  setup(props) {
    const store = useStore();

    /** Todo: document this explaining where and how it's gonna be used. */
    const settings = {
      itemsToShow: 1,
      snapAlign: "center",
      wrapAround: false
    };

    /** Todo: explain what the heck is this. */
    const breakpoints = {
      320: {
        itemsToShow: 1.25
      },

      420: {
        itemsToShow: 1.5
      },
      470: {
        itemsToShow: 1.75
      },

      560: {
        itemsToShow: 2
      },

      630: {
        itemsToShow: 3
      },

      720: {
        itemsToShow: 3.5
      },

      820: {
        itemsToShow: 3
      },

      920: {
        itemsToShow: 3.25
      },

      1020: {
        itemsToShow: 3.5
      },

      1120: {
        itemsToShow: 4
      },

      1270: {
        itemsToShow: 5
      },

      1320: {
        itemsToShow: 6
      },
      1920: {
        itemsToShow: 7
      },
      2340: {
        itemsToShow: 9
      }
    };

    const courseTracks = ref(Array<CourseTrack>());

    onBeforeMount(async () => {
      await loadCourseTracks(Number(props.entityID));
    });

    async function loadCourseTracks(schoolID: number) {
      try {
        await wrapLoading(async () => {
          courseTracks.value = await store.dispatch(
            "categories_module/loadCourseTracksOfSchool",
            schoolID
          );
        });
      } catch (e) {
        await dispatchError(e);
      }
    }

    return {
      breakpoints,
      settings,
      courseTracks
    };
  }
});
